import { set } from '@imcc/utilities';
import { SetActiveFilters } from './filters-action.interface';
import { FilterState } from './filter-state';

export function setActiveFiltersReducer(state: FilterState, action: SetActiveFilters): FilterState {
  return set(state, ['tabs', action.indexName, 'active'], action.filters);
}
